import type { TopAsset } from '@carboncopyco/types';
import { TextBase, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { Screenshot } from '../../../Screenshot';
import { TableInfoIcon } from '../../TableInfoIcon';
import { getInfoTooltipText } from '../../utils';

type TourNameProps = {
  asset: TopAsset;
  isInModal?: boolean;
};

export const TourName = ({ asset, isInModal }: TourNameProps) => {
  const { name, image } = asset;

  return (
    <TooltipBubble
      placement="top-start"
      title={name}
    >
      <div
        className={classNames('flex gap-3 items-center', {
          'pl-6': isInModal,
        })}
      >
        <div className="w-7 h-5 shrink-0">
          <Screenshot
            isOverlayTour={!image}
            image={image}
            alt="tour"
            rounded="sm"
          />
        </div>
        <div className="flex items-center gap-1.5 truncate">
          <TextBase
            label={name}
            color="text-ds-natural-600"
            ellipsis
          />
          {(asset.status === 'deleted' || asset.status === 'inactive') && (
            <TableInfoIcon
              label={getInfoTooltipText({
                assetType: 'tour',
              })}
            />
          )}
        </div>
      </div>
    </TooltipBubble>
  );
};
